import * as Immutable from "immutable";
export default class ValidationResult {
  constructor(errors, errorContext, failed) {
    this._value = {
      errors,
      errorContext,
      failed
    };
  }
  get errors() {
    return this._value.errors;
  }
  get errorContext() {
    return this._value.errorContext;
  }
  get failed() {
    return this._value.failed;
  }
  toBuilder() {
    const { errors, errorContext, failed } = this._value;
    return new Builder(
      Immutable.Map({
        errors,
        errorContext,
        failed
      })
    );
  }
  static create(errors, errorContext, failed) {
    return new ValidationResult(errors, errorContext, failed);
  }
  static createSuccess() {
    return ValidationResult.create(
      { selectedGranteeCapabilities: Immutable.List() },
      { selectedGranteeCapabilities: Immutable.List() },
      false
    );
  }
  toJSON() {
    const { errors, errorContext, failed } = this._value;
    return {
      errors: {
        selected_grantee_capabilities: errors.selectedGranteeCapabilities
      },
      error_context: {
        selected_grantee_capabilities: errorContext.selectedGranteeCapabilities
      },
      failed
    };
  }
  static fromJSON(value) {
    if (!value) {
      return ValidationResult.createSuccess();
    }
    const { errors: errorsJson, error_context, failed } = value;
    const errors = {
      selectedGranteeCapabilities: Immutable.List(errorsJson.selected_grantee_capabilities)
    };
    const errorContext = {
      selectedGranteeCapabilities: Immutable.List(error_context.selected_grantee_capabilities)
    };
    return ValidationResult.create(errors, errorContext, failed);
  }
  static builder() {
    return new Builder();
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  errors(value) {
    return new Builder(this.value.set("errors", value));
  }
  errorContext(value) {
    return new Builder(this.value.set("errorContext", value));
  }
  failed(value) {
    return new Builder(this.value.set("failed", value));
  }
  build() {
    const { errors, errorContext, failed } = this.value.toObject();
    return new ValidationResult(errors, errorContext, failed);
  }
}
